// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qc-1";
export var spinner = "_qc-0";